import { render } from "./BackorderFollowUpDatePopUp.vue?vue&type=template&id=51e4e147&scoped=true"
import script from "./BackorderFollowUpDatePopUp.vue?vue&type=script&lang=js"
export * from "./BackorderFollowUpDatePopUp.vue?vue&type=script&lang=js"

import "./BackorderFollowUpDatePopUp.vue?vue&type=style&index=0&id=51e4e147&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e4e147"]])

export default __exports__